
import React, { lazy, useEffect, useRef, useState } from "react";
import SectionSkeleton from "./sectionskeleton";
import LazySection from "components/lazySection";
const NewsDetails = lazy(() => import('components/media/new/newdetail'));

const NewBanner = lazy(() => import('components/media/new/newBanner'));
const NewsDetailPage: React.FC = () => {

  return (
    <>
      <NewBanner />
        <LazySection fallback={<SectionSkeleton height={300} />}>
        <NewsDetails />
      </LazySection> 
    </>
  );
};

export default NewsDetailPage;
